<template>
  <v-menu offset-y v-if="selectedLanguage !== ''" z-index="500">
    <template v-slot:activator="{ on }">
      <div class="flag" v-on="on">
        <country-flag size='big' :country='selectedFlag'/>
      </div>
    </template>
    <v-list two-line dense color="grey lighten-3">
      <v-list-item
        v-for="(item, index) in languages"
        :key="index" @click="setLanguage(item)">

        <v-list-item-content>
          <country-flag size='normal' :country="item.flag"></country-flag>
        </v-list-item-content>

      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue'
import CountryFlag from 'vue-country-flag'
import { SETTINGS_MODULE } from '../../store/modules'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`,
  mutationType: `${SETTINGS_MODULE}/updateField`
})

export default {
  name: 'localizationSwitcher',
  components: {
    CountryFlag
  },
  data: () => ({
    selectedLanguage: '',
    languages: [
      { label: 'ru', flag: 'rus' }, { label: 'en', flag: 'usa' }
    ]
  }),
  computed: {
    ...mapFields(['appLanguage']),
    selectedFlag () {
      return this.languages.filter(language => language.label === this.selectedLanguage)[0].flag
    }
  },
  methods: {
    setLanguage (language) {
      this.selectedLanguage = language.label
      this.$vuetify.lang.current = language.label
      this.appLanguage = this.$vuetify.lang.current
    }
  },
  beforeCreate () {
    Vue.nextTick(() => {
      // this.$vuetify.lang is not initialized in data section - instead we init current language here
      this.selectedLanguage = this.$vuetify.lang.current
    })
  }
}
</script>

<style scoped>
  .flag {
    cursor: pointer;
  }
</style>
